import { Trans } from "@lingui/macro";
import Image from "next/image";
import LumiSparkle from "@public/lumi-sparkle.svg";
import Link from "next/link";
import { NewsPageQuery } from "@graphql/generated/graphql";

const NewsPaas: React.FC<{ paas: NewsPageQuery["paas"] }> = ({ paas }) => {
  function generateSmartScriptOneLink(id: string) {
    if (typeof window == "undefined" || !window.AF_SMART_SCRIPT) return "";

    const paaPath = `/lumi-ai?questionId=${id as string}`;

    //Initializing Smart Script arguments
    var oneLinkURL = "https://luminews.onelink.me/ewC9";
    var webReferrer = "af_channel";
    var mediaSource = { defaultValue: "Lumi AI" };
    var afSub1 = { keys: ["fbclid", "twclid", "ttclid"] };
    var afSub2 = { defaultValue: "paa_organic" };
    var campaign = { keys: ["article_id"], defaultValue: paaPath };
    var deepLinkValue = { defaultValue: paaPath };
    var custom_ss_ui = { paramKey: "af_ss_ui", defaultValue: "true" };

    //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
    //Onelink URL is generated.
    var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL: oneLinkURL,
      webReferrer: webReferrer,
      afParameters: {
        mediaSource: mediaSource,
        afSub1: afSub1,
        afSub2: afSub2,
        campaign: campaign,
        deepLinkValue,
        afCustom: [custom_ss_ui],
      },
    });

    return result.clickURL;
  }

  return (
    <>
      {paas && paas.length > 1 && (
        <div className="mt-6 flex flex-col space-y-4 rounded-lg bg-off-white p-4">
          <p className="pl-1 font-poppins text-lg font-bold">
            <Trans>People also ask</Trans>
          </p>
          <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2 md:gap-y-0">
            {paas.map((paa) => {
              return (
                <Link
                  href={generateSmartScriptOneLink(paa.id)}
                  passHref
                  key={paa.id}
                >
                  <a className="flex basis-1/3 items-center rounded-3xl bg-white p-6 transition-colors duration-300 hover:bg-light-background">
                    <p className="font-sen text-sm text-text-darkest">
                      {paa.question}
                    </p>
                  </a>
                </Link>
              );
            })}
          </div>
          <div className="flex flex-row space-x-1 pl-2">
            <Image src={LumiSparkle} alt="info-icon" height={16} width={16} />
            <p className="font-sen text-sm font-bold text-text-dark">
              <Trans>Powered by Lumi AI</Trans>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsPaas;
